"use client";

import Link from "next/link";
import { PublicPricingCards } from "~/components/siteglue/public-pricing-cards";
import {
  FadeIn,
  HomeEyebrow,
  HomeHeading,
  HomeLead,
  HomeSection,
} from "~/components/siteglue/home/section-shell";
import {
  PUBLIC_PRICING_INTRO,
  PUBLIC_PRICING_STARTING_NOTE,
} from "~/lib/siteglue/public-pricing";

export function SiteGlueHomePricing({
  internStartHref: _internStartHref,
}: {
  /** Kept for callers that previously deep-linked Intern to /start. */
  internStartHref?: string;
} = {}) {
  return (
    <HomeSection id="pricing" tone="white">
      <FadeIn className="mx-auto max-w-2xl text-center">
        <HomeEyebrow>Pricing</HomeEyebrow>
        <HomeHeading className="mx-auto">Start with a free audit.</HomeHeading>
        <HomeLead className="mx-auto">{PUBLIC_PRICING_INTRO}</HomeLead>
      </FadeIn>

      <FadeIn className="mt-14">
        <PublicPricingCards />
      </FadeIn>

      <FadeIn className="mt-8 text-center text-sm text-slate-600">
        <p className="mx-auto max-w-2xl text-slate-500">{PUBLIC_PRICING_STARTING_NOTE}</p>
        <Link href="/pricing" className="mt-3 inline-block font-semibold text-[#4f81bd] underline-offset-4 hover:underline">
          See pricing
        </Link>
      </FadeIn>
    </HomeSection>
  );
}
